import { lazy } from 'react';

const CharityVettingReviewDetailsEntry = lazy(
  () =>
    import(
      /* webpackChunkName: "CharityVettingReviewDetailsContainer" */ 'features/charity-vetting/common-flow/containers/CharityVettingReviewDetailsContainer'
    ),
);

export default CharityVettingReviewDetailsEntry;
